import * as types from './types';

const INITIAL_STATE = {
  getNutritionStandards: {
    loading: false,
    data: [],
    errors: null,
  },
  getCycleMenus: {
    loading: false,
    data: [],
    errors: null,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.FOODBASEDANALYSIS_GETNUTRITIONSTANDARDS_LOADING: {
      const { getNutritionStandards } = state;
      return {
        ...state,
        getNutritionStandards: {
          ...getNutritionStandards,
          loading: action.payload,
        },
      };
    }
    case types.FOODBASEDANALYSIS_GETNUTRITIONSTANDARDS_SUCCESS: {
      const { getNutritionStandards } = state;
      return {
        ...state,
        getNutritionStandards: {
          ...getNutritionStandards,
          data: action.payload,
        },
      };
    }
    case types.FOODBASEDANALYSIS_GETNUTRITIONSTANDARDS_ERROR: {
      const { getNutritionStandards } = state;
      return {
        ...state,
        getNutritionStandards: {
          ...getNutritionStandards,
          errors: action.payload,
        },
      };
    }

    case types.FOODBASEDANALYSIS_GETCYCLEMENUS_LOADING: {
      const { getCycleMenus } = state;
      return {
        ...state,
        getCycleMenus: { ...getCycleMenus, loading: action.payload },
      };
    }
    case types.FOODBASEDANALYSIS_GETCYCLEMENUS_SUCCESS: {
      const { getCycleMenus } = state;
      return {
        ...state,
        getCycleMenus: { ...getCycleMenus, data: action.payload },
      };
    }
    case types.FOODBASEDANALYSIS_GETCYCLEMENUS_ERROR: {
      const { getCycleMenus } = state;
      return {
        ...state,
        getCycleMenus: { ...getCycleMenus, errors: action.payload },
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/reports/menus/foodbasedanalysisreport/state/reducer.js